export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/minhasAnotacoes/store/state.js